module.exports = __webpack_public_path__ + "img/warning-img02.84ed23c7.png";